import React, {useState, useContext, useEffect } from 'react';
import { useHistory  } from "react-router-dom";
import Context from '../../context/context';
import { VERSION } from '../../common/version';

function SideBar() {
    const history = useHistory();
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
      };

      useEffect(() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        setIsMobile(isMobile)
        // setIsMenuOpen(!isMobile);  
        // setIsMenuOpen(isMobile); 
        setIsMenuOpen(false) 
    }, []);

      const [isMobile, setIsMobile] = useState(false);
      const [isMenuOpen, setIsMenuOpen] = useState(true);
      const sidebarClass = isMenuOpen ? 'sideBar sideBarOpen' : 'sideBar';
      const sidebarLinksClass = isMenuOpen ? 'sideBarLinks sideBarLinksOpen' : 'sideBarLinks';
      const {state} = useContext(Context);
      const version = VERSION;

  return (
    <div>
        <div className="sideBarWrapper" style={{ display: 'flex', flexDirection: 'column' }}>
    <button className="hamburgerMenu" onClick={toggleMenu}>
        <span className="hamburgerIcon"></span>
        <span className="hamburgerIcon"></span>
        <span className="hamburgerIcon"></span>
    </button>
    <div className={sidebarClass}>
        <div className={sidebarLinksClass}>
            <p className='sideBarLink' style={{marginLeft: '30px' , marginTop:'10px'}}>VERSION {version}</p>
            <img className='sideBarLink userProfile' src={state.user?.photoURL} alt="User Profile" style={{ borderRadius: '50%', width: '60px', height: '60px' }} />
             <p className='sideBarLink' onClick={() => history.push('/invite' , { displayName: state.user.displayName ,
                email: state.user.email , 
                phoneNumber: state.user.phoneNumber ,
                photoURL: state.user.photoURL ,
                uid: state.user.uid , 
                linkType: state.linkType    } )}> הזמנת נסיעה</p>
            {/* <p className='sideBarLink' onClick={() => history.push('/Profile')}>פרופיל</p> */}
            <p className='sideBarLink' onClick={() => history.push('/priceList')}>מחירון</p>
            <p className='sideBarLink' onClick={() => history.push('/timeCalc')}>המלצות שעות יציאה</p>
            {/* <p className='sideBarLink' onClick={() => history.push('/myInvitation', { uid: state.user.uid })}>הנסיעות שלי</p> */}
            <p className='sideBarLink' onClick={() => history.push('/comments')}>הערות והארות</p>
            <p className='sideBarLink' onClick={() => history.push('/Terms')}> תנאי שימוש באתר</p>
            <p className='sideBarLink' onClick={() => history.push('/airports')}>צפה בשדות התעופה</p>
            <p className='sideBarLink' onClick={() => history.push('/askOrbit')}>בקש מסלול</p>
            <p className='sideBarLink' onClick={() => history.push('/contact')}>צור קשר</p>       
        </div>
    </div>
    </div>
    </div>
  )
}

export default SideBar